<template>
  <div v-if="!isPreview" class="antialiased mx-auto max-w-screen-sm mt-12">
    <h3 class="mb-4 text-lg font-semibold text-gray-900">{{ $t('frontend_groovemember_main_panel_comments_heading') }}</h3>
    <AddComment :isPreview="isPreview" />
    <div
      class="space-y-4 rounded-md shadow border border-grey-300 bg-white p-4"
    >
      <div class="flex">
        <div class="flex-shrink-0 mr-3">
          <img
            class="mt-2 rounded-full w-8 h-8 sm:w-10 sm:h-10"
            src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80"
            alt=""
          />
        </div>
        <div
          class="flex-1 border rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed border-grey-300"
        >
          <strong>Sarah</strong>
          <span class="text-xs text-gray-400">3:34 PM</span>
          <p class="text-sm">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua.
          </p>

          <h4
            class="my-5 uppercase tracking-wide text-gray-400 font-bold text-xs"
          >
            Replies
          </h4>

          <!-- <div class="space-y-4">
            <div class="flex">
              <div class="flex-shrink-0 mr-3">
                <img
                  class="mt-3 rounded-full w-6 h-6 sm:w-8 sm:h-8"
                  src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80"
                  alt=""
                />
              </div>
              <div
                class="flex-1 bg-gray-100 rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed border-grey-300"
              >
                <strong>Sarah</strong>
                <span class="text-xs text-gray-400">3:34 PM</span>
                <p class="text-xs sm:text-sm">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua.
                </p>
              </div>
            </div>
            <div class="flex">
              <div class="flex-shrink-0 mr-3">
                <img
                  class="mt-3 rounded-full w-6 h-6 sm:w-8 sm:h-8"
                  src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80"
                  alt=""
                />
              </div>
              <div
                class="flex-1 bg-gray-100 rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed border-grey-300"
              >
                <strong>Sarah</strong>
                <span class="text-xs text-gray-400">3:34 PM</span>
                <p class="text-xs sm:text-sm">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua.
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="flex">
        <div class="flex-shrink-0 mr-3">
          <img
            class="mt-2 rounded-full w-8 h-8 sm:w-10 sm:h-10"
            src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80"
            alt=""
          />
        </div>
        <div
          class="flex-1 border rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed border-grey-300"
        >
          <strong>Sarah</strong>
          <span class="text-xs text-gray-400">3:34 PM</span>
          <p class="text-sm">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua.
          </p>

          <h4
            class="my-5 uppercase tracking-wide text-gray-400 font-bold text-xs"
          >
            Replies
          </h4>
        </div>
      </div>

      <div class="flex">
        <div class="flex-shrink-0 mr-3">
          <img
            class="mt-2 rounded-full w-8 h-8 sm:w-10 sm:h-10"
            src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80"
            alt=""
          />
        </div>
        <div
          class="flex-1 border rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed border-grey-300"
        >
          <strong>Sarah</strong>
          <span class="text-xs text-gray-400">3:34 PM</span>
          <p class="text-sm">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua.
          </p>

          <h4
            class="my-5 uppercase tracking-wide text-gray-400 font-bold text-xs"
          >
            Replies
          </h4>
        </div>
      </div>

      <div class="flex">
        <div class="flex-shrink-0 mr-3">
          <img
            class="mt-2 rounded-full w-8 h-8 sm:w-10 sm:h-10"
            src="https://images.unsplash.com/photo-1604426633861-11b2faead63c?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=200&h=200&q=80"
            alt=""
          />
        </div>
        <div
          class="flex-1 border rounded-lg px-4 py-2 sm:px-6 sm:py-4 leading-relaxed border-grey-300"
        >
          <strong>Sarah</strong>
          <span class="text-xs text-gray-400">3:34 PM</span>
          <p class="text-sm">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua.
          </p>

          <h4
            class="my-5 uppercase tracking-wide text-gray-400 font-bold text-xs"
          >
            Replies
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddComment from './add-comment.vue';
export default {
  name: 'CommentSection',
  components: { AddComment },
  props: ['isPreview'],
};
</script>